package dev.codetwister.ctdev

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.*
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import ctdev.composeapp.generated.resources.Res
import ctdev.composeapp.generated.resources.logo
import ctdev.composeapp.generated.resources.phone_mockup
import org.jetbrains.compose.resources.painterResource

@Composable
internal fun HeroSection() {
    Row(
        horizontalArrangement = Arrangement.spacedBy(40.dp),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        LogoBadge()
        Column(
            verticalArrangement = Arrangement.spacedBy(16.dp),
        ) {
            Text(
                text = "Code twister",
                fontSize = 48.sp,
                fontWeight = FontWeight.ExtraBold,
                color = TextWhite,
            )
            Text(
                text = "I build fast, reliable Android apps in Kotlin.",
                fontSize = 18.sp,
                color = TextMuted,
                lineHeight = 28.sp,
            )
        }
    }
}

@Composable
private fun LogoBadge() {
    Image(
        painter = painterResource(Res.drawable.logo),
        contentDescription = "Code Twister logo",
        modifier = Modifier.size(230.dp),
    )
}

@Composable
fun PhoneMockup(
    modifier: Modifier = Modifier,
) {
    Image(
        modifier = modifier,
        contentScale = ContentScale.Fit,
        painter = painterResource(Res.drawable.phone_mockup),
        contentDescription = "Phone mockup with app dashboard",
    )
}

